import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.ADMIN_ASSIGNED_COMPLAINTS_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.ADMIN_ASSIGNED_COMPLAINTS_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const assignedComplaintsList = () => {
  return async (dispatch, getState) => {
    dispatch({ type: CONST.ADMIN_ASSIGNED_COMPLAINTS_LIST_REQUEST });

    const { currentUser: user } = getState().auth;

    axios
      .get(`/tickets/assigned/${user.adminId}`)
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((error) => console.error(error));
  };
};
